export default "__VITE_ASSET__CNwKIkj5__"